var map = {
	"./hellobacsi.com.json": [
		74603,
		4603
	],
	"./hellodoctor.com.ph.json": [
		34978,
		4978
	],
	"./hellodoktor.com.json": [
		24764,
		4764
	],
	"./hellosehat.com.json": [
		68873,
		8873
	],
	"./helloyishi.com.tw.json": [
		88134,
		8134
	],
	"./www.marrybaby.vn.json": [
		64272,
		4272
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47625;
module.exports = webpackAsyncContext;